<template>
  <el-dialog
    :visible.sync="showComment"
    width="600px"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="评论列表"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="comment"
  >
      <div class="comment-item" v-for="x in tableData">
        <div class="left">
          <img :src="preViewUrl+x.User.avatar">
        </div>
        <div class="right">
          <div class="item-commenter-info">
            <span>{{x.User.nickname}}</span>
            <span class="time">{{x.create_time|parseTime}}</span>
          </div>
          <div class="item-comment">
            {{x.content}}
          </div>
        </div>
        <div class="tool">
          <span>回复</span>
        </div>
      </div>
      <div class="comment-item-null" v-if="tableData.length==0">
        暂无数据
      </div>
      <div class="footer">
        <el-pagination
          :current-page="pageData.page"
          :page-size="pageData.limit"
          :total="pageData.pageTotal"
          :page-sizes="[10, 15, 20]"
          @current-change="handlerCurrentChange"
          @size-change="handlerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: -10px;"
        >
        </el-pagination>
      </div>
  </el-dialog>
</template>

<script>
import commonModels from '@/common/models/common-models'
import {listSchoolComment,listDepartMentComment} from '@/api/axj-information/axj-information-post'
export default {
  name: "comment",
  props:{
    show:{
      type:Boolean,
      default:false
    },
    postType:{
      type:String,
      default:undefined
    },
    postId:{

    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  data(){
    return{
      showComment:false,
      tableData:[],
      pageData:{
        page: 1,
        limit: 10,
        pageTotal: 8
      }
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    }
  },
  watch:{
    show(v){
      this.showComment=v
    }
  },
  methods:{
    handlerCurrentChange(row){
      this.pageData.page=row
      if(this.postType=='school'){
        this.initSchoolComment()
      }else{
        this.initDepartMentComment()
      }
    },
    handlerSizeChange(row){
      this.pageData.limit=row
      if(this.postType=='school'){
        this.initSchoolComment()
      }else{
        this.initDepartMentComment()
      }
    },
    handleOpen(){
      // console.log(this.postId)
      if(this.postType=='school'){
        this.initSchoolComment()
      }else{
        this.initDepartMentComment()
      }
    },
    initDepartMentComment(){
      listDepartMentComment(
        {
          ...this.pageData,
          where: JSON.stringify({
            notice_id: this.postId
          }),
          desc: true,
          preload: true
        }
      ).then(res=>{
        this.tableData=res.data.lists
        this.pageData.pageTotal=res.data.total
      },error => {

      })
    },
    initSchoolComment(){
      listSchoolComment({
        ...this.pageData,
        where: JSON.stringify({
          notice_id: this.postId
        }),
        desc: true,
        preload: true
      }).then(res=>{
        this.tableData=res.data.lists
        this.pageData.pageTotal=res.data.total
      },error => {

      })
    },
    handleClose(){
      this.$emit('update:show',false)
    }
  }
}
</script>

<style slot-scope lang="scss">
.comment{
  .el-dialog__body::-webkit-scrollbar{
    display: none;
  }
  .el-dialog__body{
    padding: 10px 10px 55px 10px;
    overflow-y: scroll;
    height: 400px;
  }
  .comment-item-null{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 90%;
  }
  .comment-item{
      min-height: 50px;
      width: 100%;
      margin-top: 5px;
      display: flex;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .left{
        display: flex;
        align-items: center;
        width: 50px;
        img{
          margin-left: 10px;
          width: 30px;
          height: 30px;
          border-radius: 30px;
        }
      }
      .right{
        margin-left: auto;
        .item-commenter-info{
          width: 200px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 10px;
          span{
            color: #00ADB5;
            font-size: 12px;
          }
          span[class=time]{
            font-size: 12px;
            color: #C9C9C9;
          }
        }
        .item-comment{

          font-size: 12px;
          min-height: 25px;
          width: 480px;
          margin-left: auto;
        }
      }
      .tool{
        width: 50px;
        margin-left: auto;
        color: #999999;
        font-size: 12px;
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: center;
      }
      .tool:hover{
        background-color: #bebcbc;
      }
    }
  .footer{
    justify-content: center;
    display: flex;
    align-items: center;
    width: 440px;
    height: 45px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    left: 15%;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
    z-index: 1;
    bottom: 0;

      .el-pager li{
        background: none;
        color: #ffffff;
      }
      .el-pager .active{
        color: #00adb5;
      }
      .el-input__inner{
        background: none;
        color: #ffffff;
      }
      .btn-prev{
        background: none;
        color: #ffffff;
      }
      .btn-next{
        background: none;
        color: #ffffff;
      }
      .el-pagination .el-pagination__total{
        color: #ffffff;
      }
      .el-pagination button:disabled{

        background: none;
        color: #ffffff;
      }
      .el-pagination .el-pagination__jump{
        color: #ffffff;
      }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-post/action/component/comment.vue